module.exports = __webpack_public_path__ + "static/inspiration-animated--f241d9865dea9c8c8a50774354d1fd08.gif";